import React, { useMemo } from 'react';
import { AppointmentItem } from './AppointmentItem';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../types/shared/UUID';
import { useListSigningAppointmentsQuery } from '../../../../API/order/signingAppointment/SigningAppointmentAPI';
import _ from 'lodash';
import { SchedulingCard } from '../Reusable/SchedulingCard';
import { ListTitle } from './ListTitle';
import { ListGuard } from './ListGuard';

export interface IEventsSummaryProps {
  onAddEventClick: (appointmentId?: UUID) => void;
  onViewAppointment: (appointmentId?: UUID) => void;
}

export const AppointmentsList: React.FC<IEventsSummaryProps> = ({ onViewAppointment, onAddEventClick }) => {
  const { orderId } = useParams<{ orderId: UUID; appointmentId?: UUID }>();
  const { data: signingAppointments = [] } = useListSigningAppointmentsQuery({
    orderId,
  });

  const appointmentsWithCorrections: string[] = useMemo(() => {
    return _(signingAppointments)
      .map(({ correctionTriggeredById }) => correctionTriggeredById)
      .compact()
      .value();
  }, [signingAppointments]);

  const handleNewEventClick: React.MouseEventHandler<HTMLElement> = (event) => {
    onAddEventClick();
  };

  return (
    <SchedulingCard title={<ListTitle onAddEventClick={handleNewEventClick} />}>
      <ListGuard length={signingAppointments.length} onAddEventClick={handleNewEventClick}>
        {signingAppointments.map((appointment) => (
          <AppointmentItem
            key={appointment.id}
            appointment={appointment}
            onViewAppointment={onViewAppointment}
            appointmentsWithCorrections={appointmentsWithCorrections}
            onAddEventClick={onAddEventClick}
          />
        ))}
      </ListGuard>
    </SchedulingCard>
  );
};
